<template>
  <v-card>
    <v-toolbar dense color="primary" dark>
      <v-toolbar-title>Add Metadata Schema</v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="step">
      <v-stepper-content step="1">
        <v-form v-model="isValidForm" ref="form_step1" style="width: 100%">
          <v-card-text>
            <v-layout row wrap>
              <v-text-field box label="Schema Name" v-model="schemaName" :rules="schemaNameRule"></v-text-field>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!isValidForm" @click="step=2">
              <v-icon>chevron_right</v-icon>
              {{ $t('Button.Next') }}
            </v-btn>
            <v-btn depressed @click="clickCancel">{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-form v-model="isValidForm" ref="form_step2" style="width: 100%">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 v-for="(field, i) in metadataFields" :key="field.Key">
                <v-layout row wrap>
                  <v-flex xs7 pl-2 pr-2>
                    <v-text-field box label="Field Name" v-model="field.Field" :rules="fieldNameRule"></v-text-field>
                  </v-flex>
                  <v-flex xs4 pl-2 pr-2>
                    <v-select box label="Field Type" :items="fieldTypeNames" v-model="field.FieldType" :rules="fieldTypeRule"></v-select>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn fab icon small outline color="error" @click="removeField(i)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="success" @click="addField" :disabled="!isValidForm">
                  <v-icon left>add</v-icon>
                  {{ $t('Button.Add_Metadata_Field') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!isValidForm" @click="onPostSchema">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn depressed @click="clickCancel">{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-stepper-content>
    </v-stepper>
  </v-card>
</template>

<script>
  import FormValidationUtil from '@/components/mixins/FormValidationUtil'
  import MetadataUtil from '@/components/mixins/MetadataUtil'
  import ReactivityUtil from '@/components/mixins/ReactivityUtil'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')

  export default {
    mixins: [FormValidationUtil, MetadataUtil, ReactivityUtil],
    data() {
      return {
        isValidForm: true,
        schemaName: '',
        schemaNameRule: [
          v => this.rules.required(v) || 'Schema Name is required',
        ],
        fieldNameRule: [
          v =>
          this.metadataFields.length == 1 ||
          this.rules.required(v) ||
          'Metadata Field Name is required',
        ],
        fieldTypeRule: [
          v =>
          this.rules.required(v) || 'Metadata Field Type is required',
          v =>
          this.fieldTypeNames.includes(v) ||
          `${v} is not a valid field type name`,
        ],
        step: 1,
        metadataFields: [{
          Field: '',
          FieldType: 'String',
          Key: 'default',
        }],
      }
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getMetadataSchemas', 'addSchema']),
      clickCancel() {
        this.resetForm()
        this.$emit('close')
      },
      resetForm() {
        this.step = 1
        this.schemaName = ''
        this.metadataFields = []
        this.addField()
        this.$refs.form_step1.reset()
        this.$refs.form_step1.resetValidation()
        this.$refs.form_step2.reset()
        this.$refs.form_step2.resetValidation()
      },
      addField() {
        //this.reactivePush(this.metadataFields, {
        this.metadataFields.push({
          Field: '',
          FieldType: 'String',
          Key: this.randomKey(),
        })
      },
      removeField(i) {
        if (this.metadataFields.length > 1) {
          this.metadataFields = this.arrayOmitIndex(
            this.metadataFields,
            i
          )
        } else {
          this.metadataFields[0].Field = ''
          this.metadataFields[0].FieldType = 'String'
        }
        this.$refs.form_step2.validate()
      },
      onPostSchema() {
        let that = this
        let options = {
          payload: {
            Name: this.schemaName,
            Fields: this.metadataFields
              .filter(x => !!x.Field && !!x.FieldType)
              .map(x => {
                return {
                  Field: x.Field,
                  FieldType: x.FieldType,
                }
              }),
          },
          successCb(data) {
            that.setSnackbar({
              color: 'success',
              text: `successfully added metadata schema ${data.Name}`,
            })
            that.fetchMetadataSchemas({
              forced: true,
            })
            that.clickCancel()
          },
          failedCb(msg) {
            let userMsg = `failed to post metadata schema ${msg}`
            console.error(userMsg)
            that.setSnackbar({
              color: 'error',
              text: userMsg,
            })
          },
        }
        this.addSchema(options)
      },
      fetchMetadataSchemas({
        forced,
      }) {
        let that = this
        let options = {
          successCb: () => null,
          failedCb: err => {
            console.error('failed getting metadata schemas ', err),
              that.setSnackbar({
                color: 'error',
                text: err,
              })
          },
          forced: forced || false,
        }
        this.getMetadataSchemas(options)
      },
      randomKey() {
        return Math.random()
          .toString(36)
          .substring(5)
      },
    },
    mounted() {
      this.resetForm()
    },
  }
</script>

<style scoped lang="stylus"></style>